var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isSatAdmin
    ? _c("div", { staticClass: "flex-1 position-relative" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex h-100 align-items-center justify-content-between",
          },
          [
            !_vm.isApi2Convert && !_vm.isSatAdmin
              ? _c(
                  "div",
                  {
                    staticClass:
                      "border-right border-left h-100 align-items-center px-3 hide-badger-mobile",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "user-badger",
                        class: _vm.userBadgeBg,
                        attrs: { "data-toggle": "dropdown" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "badger-icon cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openIcon.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm.hasUserActiveTeam
                              ? _c("div", [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "28",
                                        height: "25",
                                        viewBox: "0 0 28 25",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M14 14.1818C15.2538 14.1818 16.4562 13.6838 17.3427 12.7972C18.2292 11.9107 18.7273 10.7083 18.7273 9.45455C18.7273 8.2008 18.2292 6.9984 17.3427 6.11186C16.4562 5.22533 15.2538 4.72728 14 4.72728C12.7462 4.72728 11.5438 5.22533 10.6573 6.11186C9.77078 6.9984 9.27273 8.2008 9.27273 9.45455C9.27273 10.7083 9.77078 11.9107 10.6573 12.7972C11.5438 13.6838 12.7462 14.1818 14 14.1818ZM14 14.1818C12.1194 14.1818 10.3158 14.9289 8.98597 16.2587C7.65617 17.5885 6.90909 19.3921 6.90909 21.2727V24.8182M14 14.1818C15.8806 14.1818 17.6842 14.9289 19.014 16.2587C20.3438 17.5885 21.0909 19.3921 21.0909 21.2727V24.8182M15.1818 4.72728C15.6593 2.76073 17.5632 1.18182 19.9091 1.18182C22.476 1.18182 24.6127 3.29728 24.6364 5.9091C24.6127 8.52092 22.476 10.6364 19.9091 10.6364M19.9091 10.6364H18.7273M19.9091 10.6364C23.7949 10.6364 27 13.8107 27 17.7273V20.0909M12.8182 4.72728C12.3407 2.76073 10.4368 1.18182 8.09091 1.18182C5.524 1.18182 3.38727 3.29728 3.36364 5.9091C3.38727 8.52092 5.524 10.6364 8.09091 10.6364M8.09091 10.6364H9.27273M8.09091 10.6364C4.20509 10.6364 1 13.8107 1 17.7273V20.0909",
                                          stroke: "#2E2E2E",
                                          "stroke-width": "2",
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "26",
                                        height: "28",
                                        viewBox: "0 0 26 28",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M24.98 22.6989C24.3278 21.154 23.3813 19.7507 22.1933 18.5672C21.0089 17.3803 19.6059 16.434 18.0617 15.7806C18.0478 15.7736 18.034 15.7702 18.0202 15.7633C20.1742 14.2074 21.5744 11.6731 21.5744 8.81385C21.5744 4.07718 17.7367 0.239441 13 0.239441C8.26333 0.239441 4.42559 4.07718 4.42559 8.81385C4.42559 11.6731 5.82585 14.2074 7.97982 15.7667C7.96599 15.7736 7.95216 15.7771 7.93833 15.784C6.38941 16.4375 4.99952 17.3744 3.80671 18.5707C2.61981 19.7551 1.67349 21.1581 1.02003 22.7023C0.37806 24.2141 0.0318323 25.8349 8.64563e-05 27.477C-0.000836348 27.5139 0.00563604 27.5506 0.0191224 27.585C0.0326088 27.6194 0.0528363 27.6507 0.0786128 27.6771C0.104389 27.7035 0.135194 27.7245 0.16921 27.7388C0.203227 27.7532 0.239768 27.7605 0.27668 27.7605H2.35113C2.50326 27.7605 2.62427 27.6395 2.62773 27.4909C2.69688 24.8217 3.76868 22.322 5.66335 20.4273C7.62371 18.467 10.2271 17.3883 13 17.3883C15.7729 17.3883 18.3763 18.467 20.3367 20.4273C22.2313 22.322 23.3031 24.8217 23.3723 27.4909C23.3757 27.643 23.4967 27.7605 23.6489 27.7605H25.7233C25.7602 27.7605 25.7968 27.7532 25.8308 27.7388C25.8648 27.7245 25.8956 27.7035 25.9214 27.6771C25.9472 27.6507 25.9674 27.6194 25.9809 27.585C25.9944 27.5506 26.0008 27.5139 25.9999 27.477C25.9653 25.8244 25.6231 24.2167 24.98 22.6989ZM13 14.7606C11.413 14.7606 9.91943 14.1417 8.79577 13.0181C7.67211 11.8944 7.05323 10.4008 7.05323 8.81385C7.05323 7.22689 7.67211 5.73329 8.79577 4.60962C9.91943 3.48596 11.413 2.86708 13 2.86708C14.587 2.86708 16.0806 3.48596 17.2042 4.60962C18.3279 5.73329 18.9468 7.22689 18.9468 8.81385C18.9468 10.4008 18.3279 11.8944 17.2042 13.0181C16.0806 14.1417 14.587 14.7606 13 14.7606Z",
                                          fill: "#2E2E2E",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "badge-content cursor-pointer" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "cursor-pointer amount-user-credits",
                                class: {
                                  "badge-credits": _vm.isPremiumCredits,
                                  "badge-credits-free": !_vm.isPremiumCredits,
                                },
                                attrs: {
                                  "data-toggle": "tooltip",
                                  "data-placement": "right",
                                  title: "Credits",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openCredits.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("CoinSVG"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(this.availableCredit) +
                                    "\n          "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "badge-name dropdown-toggle cursor-pointer",
                              },
                              [
                                _vm.isUserRegistered &&
                                _vm.isWasUserPremium === false
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-badge-text text-uppercase",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("trans")("FREE TRIAL")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isUserPremium ||
                                (_vm.isWasUserPremium &&
                                  !_vm.hasUserActiveTeam &&
                                  !_vm.isUserEducational)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-badge-text text-uppercase",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("trans")(_vm.userProduct)
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isUserEducational
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-badge-text text-uppercase",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm._f("trans")("EDUCATION"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasUserActiveTeam
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-badge-text text-uppercase",
                                      },
                                      [_vm._v(_vm._s(_vm.activeTeam?.name))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu main-user-dropdown main-teams-dropdown dropdown-menu-left",
                            staticStyle: { "margin-top": "0px" },
                            attrs: {
                              id: "teams-dropdown-menu",
                              "aria-labelledby": "teamsDropdown",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "w-100 d-flex flex-column gap-5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center gap-10",
                                    staticStyle: { padding: "10px" },
                                  },
                                  [
                                    _vm.hasUserActiveTeam
                                      ? _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "60",
                                              height: "52",
                                              viewBox: "0 0 60 52",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M30 29.5C32.6522 29.5 35.1957 28.4464 37.0711 26.5711C38.9464 24.6957 40 22.1522 40 19.5C40 16.8478 38.9464 14.3043 37.0711 12.4289C35.1957 10.5536 32.6522 9.5 30 9.5C27.3478 9.5 24.8043 10.5536 22.9289 12.4289C21.0536 14.3043 20 16.8478 20 19.5C20 22.1522 21.0536 24.6957 22.9289 26.5711C24.8043 28.4464 27.3478 29.5 30 29.5ZM30 29.5C26.0218 29.5 22.2064 31.0804 19.3934 33.8934C16.5804 36.7064 15 40.5218 15 44.5V52M30 29.5C33.9782 29.5 37.7936 31.0804 40.6066 33.8934C43.4197 36.7064 45 40.5218 45 44.5V52M32.5 9.5C33.51 5.34 37.5375 2 42.5 2C47.93 2 52.45 6.475 52.5 12C52.45 17.525 47.93 22 42.5 22M42.5 22H40M42.5 22C50.72 22 57.5 28.715 57.5 37V42M27.5 9.5C26.49 5.34 22.4625 2 17.5 2C12.07 2 7.55 6.475 7.5 12C7.55 17.525 12.07 22 17.5 22M17.5 22H20M17.5 22C9.28 22 2.5 28.715 2.5 37V42",
                                                stroke: "#2E2E2E",
                                                "stroke-width": "4",
                                              },
                                            }),
                                          ]
                                        )
                                      : _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "48",
                                              height: "50",
                                              viewBox: "0 0 48 50",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M45.7651 40.804C44.5802 37.9973 42.8606 35.4479 40.7023 33.2977C38.5505 31.1414 36.0015 29.4221 33.196 28.2349C33.1709 28.2224 33.1458 28.2161 33.1206 28.2035C37.0339 25.3769 39.5779 20.7726 39.5779 15.5779C39.5779 6.97236 32.6056 0 24 0C15.3945 0 8.42213 6.97236 8.42213 15.5779C8.42213 20.7726 10.9661 25.3769 14.8794 28.2098C14.8543 28.2224 14.8292 28.2286 14.804 28.2412C11.99 29.4284 9.46485 31.1307 7.29776 33.304C5.14141 35.4558 3.42216 38.0048 2.23495 40.8103C1.06863 43.5569 0.439607 46.5015 0.381932 49.4849C0.380255 49.552 0.392014 49.6187 0.416516 49.6811C0.441018 49.7435 0.477767 49.8004 0.524598 49.8484C0.571428 49.8964 0.627393 49.9346 0.689194 49.9606C0.750996 49.9866 0.817383 50 0.884445 50H4.65329C4.92967 50 5.14952 49.7802 5.1558 49.5101C5.28143 44.6608 7.22867 40.1194 10.6709 36.6771C14.2324 33.1156 18.9623 31.1558 24 31.1558C29.0377 31.1558 33.7676 33.1156 37.3292 36.6771C40.7714 40.1194 42.7186 44.6608 42.8442 49.5101C42.8505 49.7864 43.0704 50 43.3468 50H47.1156C47.1827 50 47.2491 49.9866 47.3109 49.9606C47.3727 49.9346 47.4286 49.8964 47.4754 49.8484C47.5223 49.8004 47.559 49.7435 47.5835 49.6811C47.608 49.6187 47.6198 49.552 47.6181 49.4849C47.5553 46.4824 46.9334 43.5616 45.7651 40.804ZM24 26.3819C21.1169 26.3819 18.4033 25.2575 16.3618 23.2161C14.3204 21.1746 13.196 18.4611 13.196 15.5779C13.196 12.6947 14.3204 9.98116 16.3618 7.9397C18.4033 5.89824 21.1169 4.77387 24 4.77387C26.8832 4.77387 29.5968 5.89824 31.6382 7.9397C33.6797 9.98116 34.804 12.6947 34.804 15.5779C34.804 18.4611 33.6797 21.1746 31.6382 23.2161C29.5968 25.2575 26.8832 26.3819 24 26.3819Z",
                                                fill: "#2E2E2E",
                                              },
                                            }),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column",
                                        staticStyle: { "max-width": "210px" },
                                      },
                                      [
                                        !_vm.hasUserActiveTeam
                                          ? _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "font-size-125 text-truncate",
                                              },
                                              [_vm._v(_vm._s(_vm.userName))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasUserActiveTeam
                                          ? _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "font-size-125 text-truncate",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.activeTeam?.name)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.hasUserActiveTeam
                                          ? _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "font-size-75 text-truncate",
                                              },
                                              [_vm._v(_vm._s(_vm.plainEmail))]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.teams?.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center gap-10",
                                              staticStyle: {
                                                padding: "3px 10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 14 14",
                                                    fill: "none",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M7.0525 9.4325C6.71416 9.44416 6.39053 9.38886 6.0816 9.2666C5.77266 9.14433 5.5013 8.9663 5.2675 8.7325C5.0337 8.4987 4.85566 8.2362 4.7334 7.945C4.61113 7.6538 4.55 7.34463 4.55 7.0175C4.55 6.90083 4.55583 6.7872 4.5675 6.6766C4.57916 6.566 4.6025 6.45796 4.6375 6.3525C4.68416 6.2125 4.68136 6.0725 4.6291 5.9325C4.57683 5.7925 4.4863 5.69333 4.3575 5.635C4.2175 5.57667 4.08053 5.57667 3.9466 5.635C3.81266 5.69333 3.72213 5.7925 3.675 5.9325C3.61667 6.1075 3.57303 6.2825 3.5441 6.4575C3.51517 6.6325 3.50047 6.81333 3.5 7C3.5 7.46666 3.59053 7.91303 3.7716 8.3391C3.95266 8.76516 4.2063 9.1413 4.5325 9.4675C4.8475 9.79416 5.21803 10.045 5.6441 10.22C6.07016 10.395 6.51046 10.4883 6.965 10.5L6.6675 10.7975C6.5625 10.9025 6.51 11.025 6.51 11.165C6.51 11.305 6.5625 11.4275 6.6675 11.5325C6.7725 11.6375 6.895 11.69 7.035 11.69C7.175 11.69 7.2975 11.6375 7.4025 11.5325L8.5225 10.4125C8.66249 10.2725 8.7325 10.1092 8.7325 9.9225C8.7325 9.73583 8.66249 9.5725 8.5225 9.4325L7.4025 8.3125C7.2975 8.2075 7.175 8.155 7.035 8.155C6.895 8.155 6.7725 8.2075 6.6675 8.3125C6.5625 8.4175 6.51 8.54 6.51 8.68C6.51 8.82 6.5625 8.9425 6.6675 9.0475L7.0525 9.4325ZM6.93 4.55C7.26833 4.55 7.595 4.61137 7.91 4.7341C8.22499 4.85683 8.49916 5.03463 8.7325 5.2675C8.96583 5.50036 9.14386 5.76287 9.26659 6.055C9.38933 6.34713 9.45046 6.6563 9.44999 6.9825C9.44999 7.09916 9.44416 7.2128 9.43249 7.3234C9.42083 7.434 9.39749 7.54203 9.36249 7.6475C9.31583 7.7875 9.31886 7.9303 9.37159 8.0759C9.42433 8.2215 9.51463 8.3237 9.64249 8.3825C9.78249 8.44083 9.91969 8.44083 10.0541 8.3825C10.1885 8.32416 10.2788 8.225 10.325 8.085C10.3833 7.91 10.4272 7.73196 10.4566 7.5509C10.486 7.36983 10.5005 7.1862 10.5 7C10.5 6.53333 10.4153 6.0872 10.2459 5.6616C10.0765 5.236 9.82286 4.8538 9.48499 4.515C9.15833 4.18833 8.78219 3.94053 8.3566 3.7716C7.93099 3.60267 7.49046 3.51797 7.035 3.5175L7.35 3.2025C7.44333 3.0975 7.49 2.975 7.49 2.835C7.49 2.695 7.4375 2.5725 7.3325 2.4675C7.2275 2.3625 7.105 2.31 6.965 2.31C6.825 2.31 6.7025 2.3625 6.5975 2.4675L5.4775 3.5875C5.3375 3.7275 5.2675 3.89083 5.2675 4.0775C5.2675 4.26417 5.3375 4.4275 5.4775 4.5675L6.5975 5.6875C6.7025 5.7925 6.825 5.845 6.965 5.845C7.105 5.845 7.2275 5.7925 7.3325 5.6875C7.4375 5.5825 7.49 5.46 7.49 5.32C7.49 5.18 7.4375 5.0575 7.3325 4.9525L6.93 4.55ZM7 14C6.03166 14 5.12166 13.8161 4.27 13.4484C3.41833 13.0807 2.6775 12.582 2.0475 11.9525C1.4175 11.323 0.918867 10.5821 0.551601 9.73C0.184334 8.87786 0.000467552 7.96786 8.86075e-07 7C-0.00046578 6.03213 0.183401 5.12213 0.551601 4.27C0.9198 3.41787 1.41843 2.67703 2.0475 2.0475C2.67657 1.41797 3.4174 0.919333 4.27 0.5516C5.1226 0.183867 6.0326 0 7 0C7.9674 0 8.87739 0.183867 9.72999 0.5516C10.5826 0.919333 11.3234 1.41797 11.9525 2.0475C12.5816 2.67703 13.0804 3.41787 13.4491 4.27C13.8178 5.12213 14.0014 6.03213 14 7C13.9986 7.96786 13.8147 8.87786 13.4484 9.73C13.0821 10.5821 12.5834 11.323 11.9525 11.9525C11.3216 12.582 10.5807 13.0809 9.72999 13.4491C8.87926 13.8173 7.96926 14.0009 7 14ZM7 12.6C8.56333 12.6 9.88749 12.0575 10.9725 10.9725C12.0575 9.8875 12.6 8.56333 12.6 7C12.6 5.43667 12.0575 4.1125 10.9725 3.0275C9.88749 1.9425 8.56333 1.4 7 1.4C5.43666 1.4 4.1125 1.9425 3.0275 3.0275C1.9425 4.1125 1.4 5.43667 1.4 7C1.4 8.56333 1.9425 9.8875 3.0275 10.9725C4.1125 12.0575 5.43666 12.6 7 12.6Z",
                                                      fill: "#2E2E2E",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "strong",
                                                { staticClass: "font-size-75" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "Use User"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                              staticStyle: { padding: "5px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center gap-10 teams-dropdown-item",
                                                  class: {
                                                    "active-team":
                                                      !_vm.hasUserActiveTeam,
                                                  },
                                                  staticStyle: {
                                                    padding:
                                                      "10px 10px 10px 20px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setTeamActive(
                                                        "no_team"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "18",
                                                        height: "19",
                                                        viewBox: "0 0 18 19",
                                                        fill: "none",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M16.8373 15.3934L16.8376 15.3941C17.2107 16.2259 17.4277 17.1006 17.4859 18H16.6653C16.5389 16.2346 15.7502 14.5946 14.4226 13.3403C12.9698 11.9678 11.0434 11.2161 9 11.2161C6.95658 11.2161 5.03023 11.9678 3.57741 13.3403C2.24979 14.5946 1.46112 16.2346 1.33471 18H0.513703C0.571177 17.1052 0.790035 16.2247 1.16222 15.3967L1.16248 15.3961C1.58742 14.4475 2.2036 13.5837 2.9784 12.8533L2.97931 12.8524C3.75831 12.1143 4.66643 11.5356 5.68089 11.1313L5.68546 11.1295C5.68865 11.1283 5.69247 11.1269 5.69646 11.1254C5.70671 11.1214 5.72121 11.1156 5.73804 11.1076L6.52663 10.7351L5.80675 10.2428C4.43944 9.30771 3.56387 7.79863 3.56387 6.10804C3.56387 3.3126 5.96974 1 9 1C12.0303 1 14.4361 3.3126 14.4361 6.10804C14.4361 7.79871 13.5605 9.30755 12.1937 10.2403L11.4725 10.7324L12.2619 11.1054C12.2788 11.1133 12.2933 11.1192 12.3035 11.1231C12.3076 11.1247 12.3115 11.1261 12.3147 11.1273L12.3186 11.1288C13.3302 11.5333 14.2476 12.1183 15.0208 12.8503L15.0219 12.8513C15.7972 13.581 16.4133 14.4447 16.8373 15.3934ZM16.6807 18.3116L16.6806 18.3099L16.6807 18.3116ZM0.499894 18.3278L0.499955 18.3248L0.499894 18.3278ZM17.8166 18.3194L17.8829 18.4858L17.8166 18.3194ZM1.62771 18.5C1.73303 18.5 1.8168 18.4209 1.8192 18.3236L0.0132386 18.3852C0.0225753 18.4077 0.036579 18.4281 0.0544243 18.4454C0.0722696 18.4627 0.0935956 18.4764 0.117146 18.4858C0.140696 18.4952 0.165993 18.5 0.191548 18.5H1.62771ZM5.74601 9.22124C6.6195 10.0465 7.77748 10.4975 9 10.4975C10.2225 10.4975 11.3805 10.0465 12.254 9.22124C13.1284 8.39513 13.617 7.2882 13.617 6.10804C13.617 4.92788 13.1284 3.82095 12.254 2.99484C11.3805 2.16963 10.2225 1.71859 9 1.71859C7.77748 1.71859 6.6195 2.16963 5.74601 2.99484C4.87157 3.82095 4.38301 4.92788 4.38301 6.10804C4.38301 7.2882 4.87157 8.39513 5.74601 9.22124Z",
                                                          stroke: "#2E2E2E",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "text-truncate",
                                                      staticStyle: {
                                                        "max-width": "200px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.plainEmail)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.hasUserActiveTeam
                                                    ? _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                            width: "12",
                                                            height: "13",
                                                            viewBox:
                                                              "0 0 12 13",
                                                            fill: "none",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M6 12.5C7.5913 12.5 9.11742 11.8679 10.2426 10.7426C11.3679 9.61742 12 8.0913 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5C0 8.0913 0.632141 9.61742 1.75736 10.7426C2.88258 11.8679 4.4087 12.5 6 12.5ZM8.64844 5.39844L5.64844 8.39844C5.42812 8.61875 5.07188 8.61875 4.85391 8.39844L3.35391 6.89844C3.13359 6.67812 3.13359 6.32188 3.35391 6.10391C3.57422 5.88594 3.93047 5.88359 4.14844 6.10391L5.25 7.20547L7.85156 4.60156C8.07187 4.38125 8.42812 4.38125 8.64609 4.60156C8.86406 4.82188 8.86641 5.17812 8.64609 5.39609L8.64844 5.39844Z",
                                                              fill: "#1266F1",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center gap-10",
                                              staticStyle: {
                                                padding: "3px 10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 14 14",
                                                    fill: "none",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M7.0525 9.4325C6.71416 9.44416 6.39053 9.38886 6.0816 9.2666C5.77266 9.14433 5.5013 8.9663 5.2675 8.7325C5.0337 8.4987 4.85566 8.2362 4.7334 7.945C4.61113 7.6538 4.55 7.34463 4.55 7.0175C4.55 6.90083 4.55583 6.7872 4.5675 6.6766C4.57916 6.566 4.6025 6.45796 4.6375 6.3525C4.68416 6.2125 4.68136 6.0725 4.6291 5.9325C4.57683 5.7925 4.4863 5.69333 4.3575 5.635C4.2175 5.57667 4.08053 5.57667 3.9466 5.635C3.81266 5.69333 3.72213 5.7925 3.675 5.9325C3.61667 6.1075 3.57303 6.2825 3.5441 6.4575C3.51517 6.6325 3.50047 6.81333 3.5 7C3.5 7.46666 3.59053 7.91303 3.7716 8.3391C3.95266 8.76516 4.2063 9.1413 4.5325 9.4675C4.8475 9.79416 5.21803 10.045 5.6441 10.22C6.07016 10.395 6.51046 10.4883 6.965 10.5L6.6675 10.7975C6.5625 10.9025 6.51 11.025 6.51 11.165C6.51 11.305 6.5625 11.4275 6.6675 11.5325C6.7725 11.6375 6.895 11.69 7.035 11.69C7.175 11.69 7.2975 11.6375 7.4025 11.5325L8.5225 10.4125C8.66249 10.2725 8.7325 10.1092 8.7325 9.9225C8.7325 9.73583 8.66249 9.5725 8.5225 9.4325L7.4025 8.3125C7.2975 8.2075 7.175 8.155 7.035 8.155C6.895 8.155 6.7725 8.2075 6.6675 8.3125C6.5625 8.4175 6.51 8.54 6.51 8.68C6.51 8.82 6.5625 8.9425 6.6675 9.0475L7.0525 9.4325ZM6.93 4.55C7.26833 4.55 7.595 4.61137 7.91 4.7341C8.22499 4.85683 8.49916 5.03463 8.7325 5.2675C8.96583 5.50036 9.14386 5.76287 9.26659 6.055C9.38933 6.34713 9.45046 6.6563 9.44999 6.9825C9.44999 7.09916 9.44416 7.2128 9.43249 7.3234C9.42083 7.434 9.39749 7.54203 9.36249 7.6475C9.31583 7.7875 9.31886 7.9303 9.37159 8.0759C9.42433 8.2215 9.51463 8.3237 9.64249 8.3825C9.78249 8.44083 9.91969 8.44083 10.0541 8.3825C10.1885 8.32416 10.2788 8.225 10.325 8.085C10.3833 7.91 10.4272 7.73196 10.4566 7.5509C10.486 7.36983 10.5005 7.1862 10.5 7C10.5 6.53333 10.4153 6.0872 10.2459 5.6616C10.0765 5.236 9.82286 4.8538 9.48499 4.515C9.15833 4.18833 8.78219 3.94053 8.3566 3.7716C7.93099 3.60267 7.49046 3.51797 7.035 3.5175L7.35 3.2025C7.44333 3.0975 7.49 2.975 7.49 2.835C7.49 2.695 7.4375 2.5725 7.3325 2.4675C7.2275 2.3625 7.105 2.31 6.965 2.31C6.825 2.31 6.7025 2.3625 6.5975 2.4675L5.4775 3.5875C5.3375 3.7275 5.2675 3.89083 5.2675 4.0775C5.2675 4.26417 5.3375 4.4275 5.4775 4.5675L6.5975 5.6875C6.7025 5.7925 6.825 5.845 6.965 5.845C7.105 5.845 7.2275 5.7925 7.3325 5.6875C7.4375 5.5825 7.49 5.46 7.49 5.32C7.49 5.18 7.4375 5.0575 7.3325 4.9525L6.93 4.55ZM7 14C6.03166 14 5.12166 13.8161 4.27 13.4484C3.41833 13.0807 2.6775 12.582 2.0475 11.9525C1.4175 11.323 0.918867 10.5821 0.551601 9.73C0.184334 8.87786 0.000467552 7.96786 8.86075e-07 7C-0.00046578 6.03213 0.183401 5.12213 0.551601 4.27C0.9198 3.41787 1.41843 2.67703 2.0475 2.0475C2.67657 1.41797 3.4174 0.919333 4.27 0.5516C5.1226 0.183867 6.0326 0 7 0C7.9674 0 8.87739 0.183867 9.72999 0.5516C10.5826 0.919333 11.3234 1.41797 11.9525 2.0475C12.5816 2.67703 13.0804 3.41787 13.4491 4.27C13.8178 5.12213 14.0014 6.03213 14 7C13.9986 7.96786 13.8147 8.87786 13.4484 9.73C13.0821 10.5821 12.5834 11.323 11.9525 11.9525C11.3216 12.582 10.5807 13.0809 9.72999 13.4491C8.87926 13.8173 7.96926 14.0009 7 14ZM7 12.6C8.56333 12.6 9.88749 12.0575 10.9725 10.9725C12.0575 9.8875 12.6 8.56333 12.6 7C12.6 5.43667 12.0575 4.1125 10.9725 3.0275C9.88749 1.9425 8.56333 1.4 7 1.4C5.43666 1.4 4.1125 1.9425 3.0275 3.0275C1.9425 4.1125 1.4 5.43667 1.4 7C1.4 8.56333 1.9425 9.8875 3.0275 10.9725C4.1125 12.0575 5.43666 12.6 7 12.6Z",
                                                      fill: "#2E2E2E",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "strong",
                                                { staticClass: "font-size-75" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "Use Team"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                              staticStyle: { padding: "5px" },
                                            },
                                            [
                                              _vm._l(
                                                _vm.orderedTeams,
                                                function (team, index) {
                                                  return index < 2 ||
                                                    _vm.showMoreTeams
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: team.identifier,
                                                          staticClass:
                                                            "d-flex align-items-center gap-10 teams-dropdown-item",
                                                          class: {
                                                            "active-team":
                                                              team.identifier ===
                                                              _vm.activeTeam
                                                                ?.identifier,
                                                          },
                                                          staticStyle: {
                                                            padding:
                                                              "10px 10px 10px 20px",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setTeamActive(
                                                                team.identifier
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-between w-100",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-items-center gap-10",
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg",
                                                                    {
                                                                      attrs: {
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                        width:
                                                                          "20",
                                                                        height:
                                                                          "18",
                                                                        viewBox:
                                                                          "0 0 20 18",
                                                                        fill: "none",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              d: "M10 10.3182C10.868 10.3182 11.7004 9.97338 12.3142 9.35962C12.9279 8.74587 13.2727 7.91344 13.2727 7.04546C13.2727 6.17748 12.9279 5.34504 12.3142 4.73129C11.7004 4.11753 10.868 3.77273 10 3.77273C9.13202 3.77273 8.29959 4.11753 7.68583 4.73129C7.07208 5.34504 6.72727 6.17748 6.72727 7.04546C6.72727 7.91344 7.07208 8.74587 7.68583 9.35962C8.29959 9.97338 9.13202 10.3182 10 10.3182ZM10 10.3182C8.69803 10.3182 7.44938 10.8354 6.52875 11.756C5.60812 12.6767 5.09091 13.9253 5.09091 15.2273V17.6818M10 10.3182C11.302 10.3182 12.5506 10.8354 13.4713 11.756C14.3919 12.6767 14.9091 13.9253 14.9091 15.2273V17.6818M10.8182 3.77273C11.1487 2.41127 12.4668 1.31818 14.0909 1.31818C15.868 1.31818 17.3473 2.78273 17.3636 4.59091C17.3473 6.39909 15.868 7.86364 14.0909 7.86364M14.0909 7.86364H13.2727M14.0909 7.86364C16.7811 7.86364 19 10.0613 19 12.7727V14.4091M9.18182 3.77273C8.85127 2.41127 7.53318 1.31818 5.90909 1.31818C4.132 1.31818 2.65273 2.78273 2.63636 4.59091C2.65273 6.39909 4.132 7.86364 5.90909 7.86364M5.90909 7.86364H6.72727M5.90909 7.86364C3.21891 7.86364 1 10.0613 1 12.7727V14.4091",
                                                                              stroke:
                                                                                "#2E2E2E",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "strong",
                                                                    {
                                                                      staticClass:
                                                                        "text-truncate",
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "200px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          team.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              team.identifier ===
                                                              _vm.activeTeam
                                                                ?.identifier
                                                                ? _c(
                                                                    "svg",
                                                                    {
                                                                      attrs: {
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                        width:
                                                                          "12",
                                                                        height:
                                                                          "13",
                                                                        viewBox:
                                                                          "0 0 12 13",
                                                                        fill: "none",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              d: "M6 12.5C7.5913 12.5 9.11742 11.8679 10.2426 10.7426C11.3679 9.61742 12 8.0913 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5C0 8.0913 0.632141 9.61742 1.75736 10.7426C2.88258 11.8679 4.4087 12.5 6 12.5ZM8.64844 5.39844L5.64844 8.39844C5.42812 8.61875 5.07188 8.61875 4.85391 8.39844L3.35391 6.89844C3.13359 6.67812 3.13359 6.32188 3.35391 6.10391C3.57422 5.88594 3.93047 5.88359 4.14844 6.10391L5.25 7.20547L7.85156 4.60156C8.07187 4.38125 8.42812 4.38125 8.64609 4.60156C8.86406 4.82188 8.86641 5.17812 8.64609 5.39609L8.64844 5.39844Z",
                                                                              fill: "#1266F1",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.teams.length > 2
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "show-more-teams",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.showMoreTeams =
                                                            !_vm.showMoreTeams
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "strong",
                                                        {
                                                          staticClass:
                                                            "font-size-75",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("trans")(
                                                                _vm.showMoreTeams
                                                                  ? "Show Less"
                                                                  : "Show More"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                            width: "13",
                                                            height: "8",
                                                            viewBox: "0 0 13 8",
                                                            fill: "none",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M5.79374 7.20782C6.18437 7.59844 6.81874 7.59844 7.20937 7.20782L12.2094 2.20782C12.6 1.81719 12.6 1.18282 12.2094 0.792191C11.8187 0.401566 11.1844 0.401566 10.7937 0.792191L6.49999 5.08594L2.20624 0.795315C1.81562 0.40469 1.18124 0.40469 0.790619 0.795315C0.399994 1.18594 0.399994 1.82032 0.790619 2.21094L5.79062 7.21094L5.79374 7.20782Z",
                                                              fill: "#6C757D",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.teams?.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "border-bottom",
                                        staticStyle: { padding: "5px 15px" },
                                      },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticClass:
                                              "font-size-75 text-muted",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")("Explore Teams")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-start align-items-center gap-5 p-2",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "teams-dropdown-item-link",
                                        attrs: { href: _vm.linkTeamCreate },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openTeamCreate()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "icon-container" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "18",
                                                  height: "18",
                                                  viewBox: "0 0 18 18",
                                                  fill: "none",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M3.69759 8.99951C3.69759 8.78865 3.7815 8.58644 3.93085 8.43734C4.0802 8.28824 4.28276 8.20448 4.49397 8.20448H8.20297V4.50178C8.20297 4.29093 8.28687 4.08871 8.43622 3.93961C8.58557 3.79052 8.78813 3.70676 8.99934 3.70676C9.21056 3.70676 9.41312 3.79052 9.56247 3.93961C9.71182 4.08871 9.79572 4.29093 9.79572 4.50178V8.20448H13.5047C13.7159 8.20448 13.9185 8.28824 14.0678 8.43734C14.2172 8.58644 14.3011 8.78865 14.3011 8.99951C14.3011 9.21036 14.2172 9.41258 14.0678 9.56167C13.9185 9.71077 13.7159 9.79453 13.5047 9.79453H9.79572V13.4972C9.79572 13.7081 9.71182 13.9103 9.56247 14.0594C9.41312 14.2085 9.21056 14.2923 8.99934 14.2923C8.78813 14.2923 8.58557 14.2085 8.43622 14.0594C8.28687 13.9103 8.20297 13.7081 8.20297 13.4972V9.79453H4.49397C4.28276 9.79453 4.0802 9.71077 3.93085 9.56167C3.7815 9.41258 3.69759 9.21036 3.69759 8.99951Z",
                                                    fill: "#2E2E2E",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d: "M4.02676 0.27433C7.33169 -0.0914434 10.667 -0.0914434 13.9719 0.27433C15.9119 0.490577 17.4781 2.01597 17.7053 3.96325C18.0982 7.30978 18.0982 10.6902 17.7053 14.0368C17.477 15.984 15.9108 17.5084 13.9719 17.7257C10.667 18.0914 7.33169 18.0914 4.02676 17.7257C2.08678 17.5084 0.520573 15.984 0.29334 14.0368C-0.09778 10.6903 -0.09778 7.30973 0.29334 3.96325C0.520573 2.01597 2.08784 0.490577 4.02676 0.27433ZM13.7957 1.85378C10.6079 1.50103 7.39081 1.50103 4.20302 1.85378C3.6129 1.91914 3.06208 2.1812 2.63955 2.59762C2.21702 3.01405 1.94746 3.56052 1.87441 4.14875C1.49675 7.37228 1.49675 10.6288 1.87441 13.8523C1.94768 14.4403 2.21734 14.9866 2.63985 15.4028C3.06236 15.819 3.61306 16.0809 4.20302 16.1462C7.36411 16.4982 10.6346 16.4982 13.7957 16.1462C14.3854 16.0807 14.9359 15.8187 15.3582 15.4025C15.7805 14.9863 16.05 14.4402 16.1232 13.8523C16.5009 10.6288 16.5009 7.37228 16.1232 4.14875C16.0498 3.56106 15.7802 3.0152 15.3579 2.59922C14.9356 2.18324 14.3853 1.92139 13.7957 1.8559",
                                                    fill: "#2E2E2E",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Create Team")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.teams?.length > 0 &&
                                    _vm.isActiveTeamOwner
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "teams-dropdown-item-link",
                                            attrs: {
                                              href: _vm.linkTeamProfile,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.openTeamProfile()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "icon-container" },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                      width: "18",
                                                      height: "18",
                                                      viewBox: "0 0 18 18",
                                                      fill: "none",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M8.4 8.99532C8.4 8.33282 8.16563 7.76719 7.69688 7.29844C7.22813 6.82969 6.6625 6.59532 6 6.59532C5.3375 6.59532 4.77188 6.82969 4.30313 7.29844C3.83438 7.76719 3.6 8.33282 3.6 8.99532C3.6 9.65782 3.83438 10.2234 4.30313 10.6922C4.77188 11.1609 5.3375 11.3953 6 11.3953C6.6625 11.3953 7.22813 11.1609 7.69688 10.6922C8.16563 10.2234 8.4 9.65782 8.4 8.99532ZM15.6 13.7953C15.6 13.4703 15.4813 13.1891 15.2438 12.9516C15.0063 12.7141 14.725 12.5953 14.4 12.5953C14.075 12.5953 13.7938 12.7141 13.5563 12.9516C13.3188 13.1891 13.2 13.4703 13.2 13.7953C13.2 14.1266 13.3172 14.4094 13.5516 14.6438C13.7859 14.8781 14.0688 14.9953 14.4 14.9953C14.7313 14.9953 15.0141 14.8781 15.2484 14.6438C15.4828 14.4094 15.6 14.1266 15.6 13.7953ZM15.6 4.19532C15.6 3.87032 15.4813 3.58907 15.2438 3.35157C15.0063 3.11407 14.725 2.99532 14.4 2.99532C14.075 2.99532 13.7938 3.11407 13.5563 3.35157C13.3188 3.58907 13.2 3.87032 13.2 4.19532C13.2 4.52657 13.3172 4.80938 13.5516 5.04375C13.7859 5.27813 14.0688 5.39532 14.4 5.39532C14.7313 5.39532 15.0141 5.27813 15.2484 5.04375C15.4828 4.80938 15.6 4.52657 15.6 4.19532ZM12 8.14219V9.87657C12 9.93907 11.9781 10 11.9344 10.0594C11.8906 10.1188 11.8406 10.1516 11.7844 10.1578L10.3313 10.3828C10.2625 10.6016 10.1625 10.8391 10.0312 11.0953C10.2438 11.3953 10.525 11.7547 10.875 12.1734C10.9188 12.2422 10.9406 12.3047 10.9406 12.3609C10.9406 12.4359 10.9188 12.4953 10.875 12.5391C10.7313 12.7266 10.4734 13.0063 10.1016 13.3781C9.72969 13.75 9.48438 13.9359 9.36563 13.9359C9.29688 13.9359 9.23125 13.9141 9.16875 13.8703L8.09063 13.0266C7.85938 13.1453 7.61875 13.2422 7.36875 13.3172C7.3 13.9922 7.22813 14.4766 7.15313 14.7703C7.10938 14.9203 7.01563 14.9953 6.87188 14.9953H5.12813C5.05938 14.9953 4.99688 14.9719 4.94063 14.925C4.88438 14.8781 4.85313 14.8234 4.84688 14.7609L4.63125 13.3266C4.41875 13.2641 4.18438 13.1672 3.92813 13.0359L2.82188 13.8703C2.77813 13.9141 2.71563 13.9359 2.63438 13.9359C2.56563 13.9359 2.5 13.9109 2.4375 13.8609C1.5375 13.0297 1.0875 12.5297 1.0875 12.3609C1.0875 12.3047 1.10938 12.2453 1.15313 12.1828C1.21563 12.0953 1.34375 11.9297 1.5375 11.6859C1.73125 11.4422 1.87813 11.2516 1.97813 11.1141C1.83438 10.8391 1.725 10.5828 1.65 10.3453L0.225 10.1203C0.1625 10.1141 0.109375 10.0844 0.065625 10.0313C0.021875 9.97813 0 9.91719 0 9.84844V8.11407C0 8.05157 0.021875 7.99063 0.065625 7.93125C0.109375 7.87188 0.159375 7.83907 0.215625 7.83282L1.66875 7.60782C1.7375 7.38907 1.8375 7.15157 1.96875 6.89532C1.75625 6.59532 1.475 6.23594 1.125 5.81719C1.08125 5.74844 1.05938 5.68594 1.05938 5.62969C1.05938 5.55469 1.08125 5.49219 1.125 5.44219C1.2625 5.25469 1.51875 4.97657 1.89375 4.60782C2.26875 4.23907 2.51562 4.05469 2.63438 4.05469C2.70312 4.05469 2.76875 4.07657 2.83125 4.12032L3.90938 4.96407C4.12188 4.85157 4.3625 4.75157 4.63125 4.66407C4.7 3.98907 4.77188 3.50782 4.84688 3.22032C4.89062 3.07032 4.98438 2.99532 5.12813 2.99532H6.87188C6.94063 2.99532 7.00313 3.01875 7.05938 3.06563C7.11563 3.1125 7.14688 3.16719 7.15313 3.22969L7.36875 4.66407C7.58125 4.72657 7.81563 4.82344 8.07188 4.95469L9.17813 4.12032C9.22813 4.07657 9.29063 4.05469 9.36563 4.05469C9.43438 4.05469 9.5 4.07969 9.5625 4.12969C10.4625 4.96094 10.9125 5.46094 10.9125 5.62969C10.9125 5.67969 10.8906 5.73907 10.8469 5.80782C10.7719 5.90782 10.6406 6.07657 10.4531 6.31407C10.2656 6.55157 10.125 6.73907 10.0312 6.87657C10.175 7.17657 10.2812 7.43282 10.35 7.64532L11.775 7.86094C11.8375 7.87344 11.8906 7.90625 11.9344 7.95938C11.9781 8.0125 12 8.07344 12 8.14219ZM18 13.1391V14.4516C18 14.5516 17.5344 14.6484 16.6031 14.7422C16.5281 14.9109 16.4344 15.0734 16.3219 15.2297C16.6406 15.9359 16.8 16.3672 16.8 16.5234C16.8 16.5484 16.7875 16.5703 16.7625 16.5891C16 17.0328 15.6125 17.2547 15.6 17.2547C15.55 17.2547 15.4063 17.1078 15.1688 16.8141C14.9313 16.5203 14.7688 16.3078 14.6813 16.1766C14.5563 16.1891 14.4625 16.1953 14.4 16.1953C14.3375 16.1953 14.2438 16.1891 14.1188 16.1766C14.0313 16.3078 13.8688 16.5203 13.6313 16.8141C13.3938 17.1078 13.25 17.2547 13.2 17.2547C13.1875 17.2547 12.8 17.0328 12.0375 16.5891C12.0125 16.5703 12 16.5484 12 16.5234C12 16.3672 12.1594 15.9359 12.4781 15.2297C12.3656 15.0734 12.2719 14.9109 12.1969 14.7422C11.2656 14.6484 10.8 14.5516 10.8 14.4516V13.1391C10.8 13.0391 11.2656 12.9422 12.1969 12.8484C12.2781 12.6672 12.3719 12.5047 12.4781 12.3609C12.1594 11.6547 12 11.2234 12 11.0672C12 11.0422 12.0125 11.0203 12.0375 11.0016C12.0625 10.9891 12.1719 10.9266 12.3656 10.8141C12.5594 10.7016 12.7438 10.5953 12.9188 10.4953C13.0938 10.3953 13.1875 10.3453 13.2 10.3453C13.25 10.3453 13.3938 10.4906 13.6313 10.7813C13.8688 11.0719 14.0313 11.2828 14.1188 11.4141C14.2438 11.4016 14.3375 11.3953 14.4 11.3953C14.4625 11.3953 14.5563 11.4016 14.6813 11.4141C15 10.9703 15.2875 10.6203 15.5438 10.3641L15.6 10.3453C15.625 10.3453 16.0125 10.5641 16.7625 11.0016C16.7875 11.0203 16.8 11.0422 16.8 11.0672C16.8 11.2234 16.6406 11.6547 16.3219 12.3609C16.4281 12.5047 16.5219 12.6672 16.6031 12.8484C17.5344 12.9422 18 13.0391 18 13.1391ZM18 3.53907V4.85157C18 4.95157 17.5344 5.04844 16.6031 5.14219C16.5281 5.31094 16.4344 5.47344 16.3219 5.62969C16.6406 6.33594 16.8 6.76719 16.8 6.92344C16.8 6.94844 16.7875 6.97032 16.7625 6.98907C16 7.43282 15.6125 7.65469 15.6 7.65469C15.55 7.65469 15.4063 7.50782 15.1688 7.21407C14.9313 6.92032 14.7688 6.70782 14.6813 6.57657C14.5563 6.58907 14.4625 6.59532 14.4 6.59532C14.3375 6.59532 14.2438 6.58907 14.1188 6.57657C14.0313 6.70782 13.8688 6.92032 13.6313 7.21407C13.3938 7.50782 13.25 7.65469 13.2 7.65469C13.1875 7.65469 12.8 7.43282 12.0375 6.98907C12.0125 6.97032 12 6.94844 12 6.92344C12 6.76719 12.1594 6.33594 12.4781 5.62969C12.3656 5.47344 12.2719 5.31094 12.1969 5.14219C11.2656 5.04844 10.8 4.95157 10.8 4.85157V3.53907C10.8 3.43907 11.2656 3.34219 12.1969 3.24844C12.2781 3.06719 12.3719 2.90469 12.4781 2.76094C12.1594 2.05469 12 1.62344 12 1.46719C12 1.44219 12.0125 1.42032 12.0375 1.40157C12.0625 1.38907 12.1719 1.32657 12.3656 1.21407C12.5594 1.10157 12.7438 0.995316 12.9188 0.895316C13.0938 0.795316 13.1875 0.745316 13.2 0.745316C13.25 0.745316 13.3938 0.890628 13.6313 1.18125C13.8688 1.47188 14.0313 1.68282 14.1188 1.81407C14.2438 1.80157 14.3375 1.79532 14.4 1.79532C14.4625 1.79532 14.5563 1.80157 14.6813 1.81407C15 1.37032 15.2875 1.02032 15.5438 0.764066L15.6 0.745316C15.625 0.745316 16.0125 0.964066 16.7625 1.40157C16.7875 1.42032 16.8 1.44219 16.8 1.46719C16.8 1.62344 16.6406 2.05469 16.3219 2.76094C16.4281 2.90469 16.5219 3.06719 16.6031 3.24844C17.5344 3.34219 18 3.43907 18 3.53907Z",
                                                        fill: "#2E2E2E",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")("Settings")
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-toggle cursor-pointer d-md-flex align-items-center menu-badge mx-2",
                  staticStyle: { "z-index": "100" },
                  attrs: {
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [
                  _c("span", { staticClass: "hidden-mobile" }, [
                    _vm._v(_vm._s(_vm._f("trans")("Menu"))),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-bars fg-normal fa-lg" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu main-user-dropdown dropdown-menu-right w-100 border bg-white border-top",
                  staticStyle: { padding: "20px 10px", "margin-top": "-1px" },
                  attrs: { id: "dropdown-menu-hover" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "list-unstyled d-flex flex-column gap-20" },
                    [
                      !_vm.isSatAdmin
                        ? [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column gap-5" },
                              [
                                _vm.shouldShowUpgradeBox
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card text-white mt-1 br-4",
                                        class: {
                                          "bg-premium-dark":
                                            !_vm.shouldShowEducationalClaim,
                                          "bg-education-i":
                                            _vm.shouldShowEducationalClaim,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body p-3" },
                                          [
                                            _c("p", {
                                              staticClass: "mb-3",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.descriptionUpgradeBox
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-block btn-warning text-dark d-flex align-items-center justify-content-center",
                                                attrs: {
                                                  "data-user-button-upgrade":
                                                    "",
                                                  href: "#",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.clickUpgradeButton.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.textUpgradeButton)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.shouldShowBuyMore
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-block btn-warning text-dark",
                                          attrs: {
                                            "data-user-button-upgrade": "",
                                            href: "#",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.clickBuyMoreCredits.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "w-100 gap-30 d-flex align-items-center px-4",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-chevron-right",
                                              }),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("trans")(
                                                      "Get more Credits"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showSale
                                  ? _c("div", [
                                      _vm.isUserRegistered && !_vm.isApi2Convert
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card premium-bg text-white mt-1",
                                              staticStyle: {
                                                "border-radius": "4px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "card-body p-3",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm._f("trans")(
                                                          "Use some of our finest tools for a low cost. Hurry, the offer expires on %sale_end%.",
                                                          {
                                                            "%sale_end%":
                                                              "November 30, 2022",
                                                          }
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-block btn-warning text-dark mb-2",
                                                      attrs: {
                                                        "data-user-button-upgrade":
                                                          "",
                                                        href: "#",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          $event.preventDefault()
                                                          return _vm.clickUpgradeButton.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.textSaleButton
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-white p-2 text-underline",
                                                      staticStyle: {
                                                        color:
                                                          "#fff !important",
                                                      },
                                                      attrs: {
                                                        href: _vm.linkSale,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "Learn more"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item hidden-in-user-area header-dropdown-item",
                                    attrs: { href: _vm.linkRecentTasks },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "icon-container" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "28",
                                                  height: "30",
                                                  viewBox: "0 0 28 30",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                                                    fill: "currentColor",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Recent Tasks")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column gap-5" },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm._f("trans")("Account"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item hidden-in-user-area header-dropdown-item",
                                    attrs: { href: _vm.linkDashboard },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "icon-container" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "24",
                                                  height: "28",
                                                  viewBox: "0 0 24 28",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z",
                                                    fill: "currentColor",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Dashboard"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item header-dropdown-item",
                                    attrs: { href: _vm.linkSocial },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Linked Accounts")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item hover-danger logout-btn",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.logoutUser.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "icon-container" },
                                          [
                                            _c("i", {
                                              class: {
                                                "far fa-sign-out":
                                                  !_vm.isLoggingOut,
                                                "fa fa-spinner fa-spin":
                                                  _vm.isLoggingOut,
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Logout"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isApi2Convert === true
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-lg-none pl-0 api2convert-items d-flex flex-column gap-5",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item header-dropdown-item",
                                        attrs: { href: _vm.linkDocumentation },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex gap-20 align-items-center",
                                          },
                                          [
                                            _vm._m(2),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")(
                                                    "Documentation"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item header-dropdown-item",
                                        attrs: { href: _vm.linkFileFormats },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex gap-20 align-items-center",
                                          },
                                          [
                                            _vm._m(3),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")(
                                                    "File Formats"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item header-dropdown-item",
                                        attrs: { href: _vm.linkBlog },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex gap-20 align-items-center",
                                          },
                                          [
                                            _vm._m(4),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(_vm._f("trans")("Blog"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pl-0 hidden-in-user-area d-flex flex-column gap-5",
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm._f("trans")("Billing"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item header-dropdown-item",
                                    attrs: { href: _vm.linkInvoices },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-20 align-items-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "icon-container" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "18",
                                                  height: "20",
                                                  viewBox: "0 0 18 20",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M0 0V18H11.0769V16.6154H1.38462V1.38462H8.30769V5.53846H12.4615V6.92308H13.8462V4.56923L13.6385 4.36154L9.48462 0.207692L9.27692 0H0ZM9.69231 2.35385L11.4923 4.15385H9.69231V2.35385ZM2.76923 6.92308V8.30769H11.0769V6.92308H2.76923ZM14.5385 8.30769V9.69231C13.3615 9.9 12.4615 10.8692 12.4615 12.1154C12.4615 13.5 13.5 14.5385 14.8846 14.5385H15.5769C16.1308 14.5385 16.6154 15.0231 16.6154 15.5769C16.6154 16.1308 16.1308 16.6154 15.5769 16.6154H13.1538V18H14.5385V19.3846H15.9231V18C17.1 17.7923 18 16.8231 18 15.5769C18 14.1923 16.9615 13.1538 15.5769 13.1538H14.8846C14.3308 13.1538 13.8462 12.6692 13.8462 12.1154C13.8462 11.5615 14.3308 11.0769 14.8846 11.0769H17.3077V9.69231H15.9231V8.30769H14.5385ZM2.76923 10.3846V11.7692H7.61539V10.3846H2.76923ZM9 10.3846V11.7692H11.0769V10.3846H9ZM2.76923 13.1538V14.5385H7.61539V13.1538H2.76923ZM9 13.1538V14.5385H11.0769V13.1538H9Z",
                                                    fill: "currentColor",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Invoices"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.shouldShowCredits
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item header-dropdown-item",
                                        attrs: { href: _vm.linkCredits },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex gap-20 align-items-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "badge badge-warning",
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                      width: "16",
                                                      height: "16",
                                                      viewBox: "0 0 16 16",
                                                      fill: "none",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M8 3.33334C9.72799 3.33334 11.324 3.64334 12.5133 4.17201C13.1067 4.43601 13.6293 4.76734 14.0113 5.16934C14.3973 5.57334 14.6667 6.08134 14.6667 6.66668V9.33334C14.6667 9.91868 14.3973 10.426 14.0113 10.8307C13.6293 11.2327 13.1073 11.564 12.5133 11.828C11.324 12.3567 9.72799 12.6667 8 12.6667C6.272 12.6667 4.676 12.3567 3.48666 11.828C2.89333 11.564 2.37066 11.2327 1.98866 10.8307C1.60266 10.4267 1.33333 9.91868 1.33333 9.33334V6.66668C1.33333 6.08134 1.60266 5.57401 1.98866 5.16934C2.37066 4.76734 2.89266 4.43601 3.48666 4.17201C4.676 3.64334 6.272 3.33334 8 3.33334ZM13.3333 8.72001C13.0833 8.88401 12.8067 9.03068 12.5133 9.16134C11.324 9.69001 9.72799 10 8 10C6.272 10 4.676 9.69001 3.48666 9.16134C3.20193 9.03648 2.92771 8.88889 2.66666 8.72001V9.33334C2.66666 9.48468 2.73333 9.67868 2.95466 9.91201C3.17933 10.148 3.53599 10.3913 4.02799 10.61C5.01066 11.0467 6.41466 11.3333 8 11.3333C9.58599 11.3333 10.9893 11.0467 11.972 10.61C12.464 10.3913 12.8207 10.148 13.0453 9.91201C13.2673 9.67868 13.3333 9.48468 13.3333 9.33334V8.72001ZM8 4.66668C6.414 4.66668 5.01066 4.95334 4.02799 5.39001C3.53599 5.60868 3.17933 5.85201 2.95466 6.08801C2.73266 6.32134 2.66666 6.51534 2.66666 6.66668C2.66666 6.81801 2.73333 7.01201 2.95466 7.24534C3.17933 7.48134 3.53599 7.72468 4.02799 7.94334C5.01066 8.38001 6.41466 8.66668 8 8.66668C9.58599 8.66668 10.9893 8.38001 11.972 7.94334C12.464 7.72468 12.8207 7.48134 13.0453 7.24534C13.2673 7.01201 13.3333 6.81801 13.3333 6.66668C13.3333 6.51534 13.2667 6.32134 13.0453 6.08801C12.8207 5.85201 12.464 5.60868 11.972 5.39001C10.9893 4.95401 9.58533 4.66668 8 4.66668Z",
                                                        fill: "#2E2E2E",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")("Credits")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isApi2Convert
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.clickUpgradeButton.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex gap-20 align-items-center",
                                          },
                                          [
                                            _vm._m(5),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")("Buy Credits")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "d-flex flex-column gap-20",
                              attrs: { id: "user-nav-top" },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "badge-toggle dropdown-toggle cursor-pointer",
        attrs: { id: "teamsDropdown", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "fa fa-chevron-down" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-link" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fad fa-book" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa fa-file-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa-blog" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "far fa-shopping-cart" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }